import { BA_COVERAGE } from './baCoverageSpec';
import type { IBaCoverage } from './IBaCoverage';
import type { IBaCoverageStats } from './IBaCoverageStats';
import type { IBaRowSource } from './IBaRowSource';

/**
 * Покриття аналізом за правилами прототипу v4 (isBaDash): клітинка — записи виду для модуля, насиченість — min(1, n / max × 2.5), де max —
 * найбільша кількість «модуль × вид» серед усіх видів; прогалина — нульова клітинка; «Виконані вимоги» — вимоги зі статусом Implemented /
 * Verified до всіх вимог модуля (без вимог — 0); повністю покрито — рядок без прогалин; сторони — у порядку варіантів поля. Чиста функція.
 */
export function baCoverageOf(sources: IBaRowSource[], stats: IBaCoverageStats, stakeholders: readonly string[]): IBaCoverage {
  const counts = Object.values(stats.byKindModule).flatMap((byModule) => Object.values(byModule));
  const max = Math.max(1, ...counts);
  const rows = sources.map(({ value, category }) => {
    const cells = BA_COVERAGE.matrixKinds.map((kind) => {
      const count = stats.byKindModule[kind]?.[value] ?? 0;
      return { kind, count, alpha: Math.min(1, (count / max) * 2.5) };
    });
    const requirements = stats.byKindModule[BA_COVERAGE.requirement]?.[value] ?? 0;
    const done = stats.doneByModule[value] ?? 0;
    return { value, category, cells, gaps: cells.filter((c) => !c.count).length, requirements, done, pct: requirements ? Math.round((done / requirements) * 100) : 0 };
  });
  return {
    total: stats.total,
    full: rows.filter((r) => !r.gaps).length,
    gaps: rows.reduce((sum, r) => sum + r.gaps, 0),
    rows,
    byKind: stats.byKind,
    stakes: stakeholders.map((value) => ({ value, counts: BA_COVERAGE.stakeKinds.map((kind) => stats.byKindStake[kind]?.[value] ?? 0) })),
  };
}
